import styles from "./index.module.scss";
import { Category } from "../category";
import { SearchInput } from "../search-input";
import { useLocation } from "react-router-dom";

export type SearchPropsType = {
  layout?: "horzontal" | "vertical";
  noSearch?: boolean;
};

export const Search = (props: SearchPropsType) => {
  const { noSearch = false } = props;
  const location = useLocation();
  const isBusinessOpportunity = location.pathname.includes("business-opportunity");

  return (
    <div className={styles.layoutSearch}>
      <div className={styles.layoutMainSearch}>
        {!noSearch ? <SearchInput /> : null}
        {!isBusinessOpportunity && <Category {...props} />}
      </div>
    </div>
  );
};

export { SimpleSearch } from './simple-search';
export { SSearch } from './s-search';
export { SimpleBusinessSearch } from './simple-business-search';
